import React, { Component } from 'react'

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">highlights</span>
                <h2 className="colorlib-heading animate-box">Timeline</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="timeline-centered">
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>China Resources Pharmaceutical（Senior front-end development engineer） <span>2022/11-2024/2</span></h2>
                        <h4>technology stack</h4>
                        <p>1. PC mall system technology stack: vue3+pinia+typescript+sass</p>
                        <p>2. Business-side and platform-side technology stack: vue2+ant.design.vue+pinia+typescript+sass</p>
                        <p>3. WeChat applet and official account technology stack: uniapp+vue3+sass</p>
                        <h4>Responsibilities</h4>
                        <p>1. Technical selection and construction of the medical mall system, and the project will be put into operation from 0 to 1</p>
                        <p>2. Customize the UI framework in the system to make the entire system more consistent with the user experience</p>
                        <p>3. Optimize the front-end performance of the product display module to enhance user experience</p>
                        <p>4. Optimization of product details page display and encapsulation of shopping cart module purchase components to make development more convenient</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInTop">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Blockchain China(Senior front-end development engineer) <span>2019/12-2022/10</span></h2>
                        <h4>technology stack</h4>
                        <p>1. Development environment: mac + node + vscode + chrome (safari)</p>
                        <p>2. PC system technology stack: react + react-redux + material/custom UI component library + ts + sass</p>
                        <p>3. PC desktop application: PC system + electron technology package development</p>
                        <p>4. Mobile system technology stack: react-native + react-redux</p>
                        <p>5. H5 system technology stack: react + react-redux + custom UI component library + ts + sass</p>
                        <p>6. Backend Sass system: react + react-redux + ant.design + ts + sass</p>

                        <h4>Responsibilities</h4>
                        <p>1. Responsible modules: PC system, PC desktop, Sass system, H5 system, mobile react-native</p>
                        <p>2. Quotation module, ranking list, price increase and decrease ranking, transaction ranking list, currency buying and selling module development</p>
                        <p>3. Cryptocurrency ranking development: IOS wallet, Android wallet, PC wallet, hardware wallet, Web wallet, public chain development</p>
                        <p>4. OTC trading module, K-line module, trading pair information, user assets, and order record module development</p>
                        <p>5. In the Sass system, language package configuration, announcement configuration, and homepage configuration module development</p>
                        <p>6. H5 activity page is nested in Android, iOS, and react-native for development</p>
                        <p>7. Solve daily problems on sentry and arms system monitoring online</p>
                        <p>8. Cooperate with operation and maintenance personnel to configure multi-domain name deployment and multi-link switching mechanism</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-5">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>Gongdao Network Technology Co., Ltd. <span>2016/7-2019/11</span></h2>
                        <h4>technology stack</h4>
                        <p>1. Development environment: window+node+vscode+chrome</p>
                        <p>2. Old system technology stack: html+js+css+gulp+jquery+handlebars+velocity+tomcat+maven</p>
                        <p>3. New system: react+react-redux+ant.design+less+webpack</p>
                        <p>4. Industrial and commercial mediation project: react+umi+less</p>
                        <h4>Resonsibilities</h4>
                        <p>1. Daily demand development is delivered on time, meets requirements, meets quality standards, and improves code quality, performance optimization, user experience, etc.</p>
                        <p>2. Improve cooperation and communication skills in the team, and be able to effectively cooperate with desi</p>
                        <p>3. Be more proficient in mastering the front-end technology stack, improve your ability to learn new technologies, and solve technical problems</p>
                        <p>4. A low-code visual large-screen system was built from 0 to 1 to make reporting data more intuitive and easier to use.</p>
                      </div>
                    </div>
                  </article>
                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
